// extracted by mini-css-extract-plugin
export default {"memoryCard":"Card_memoryCard__jFSHb","cardCover":"Card_cardCover__Q9rJq","card":"Card_card__ubWxt","flipped":"Card_flipped__qpuMv"};